import {
  UserSubscriptionResponseSchema,
  type UserSubscriptionResponse,
} from '@hedepy/common/schemas/routes/api/v2/userSubscription'

import { useApis } from '@/legacy-src/contexts/api-context'

import { useSwrQuery, type SwrQueryOptions } from '@/src/domains/swr/hooks/useSwrQuery'

export const getGetUserSubscriptionSWRKey = () => ['user-subscription', 'GET'] as const

/**
 * The subscription state for the current calendar month, plus whatever changes next month. Singular and
 * month-scoped, so it answers page-level questions — to follow one row through a payment use
 * `useGetUserSubscriptionDetail` instead.
 */
export const useGetUserSubscription = <Config extends SwrQueryOptions<UserSubscriptionResponse> | undefined>(
  options?: Config,
) => {
  const { api } = useApis()

  return useSwrQuery(
    getGetUserSubscriptionSWRKey(),
    async () => {
      const { data } = await api.getUserSubscription()

      return UserSubscriptionResponseSchema.parse(data)
    },
    options,
  )
}
